const each = require('./each');
const extend = require('./extend');

module.exports = serialize;

function serialize(data) {
  const query = [];
  each(data, (value, key) => {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    query.push(`${key}=${encodeURIComponent(value)}`);
  });
  return query.join('&');
}
